<template>
  <div class="dropbox">
    <input
      type="file"
      @change="filesChange($event.target.name, $event.target.files)"
      accept=".pdf"
      class="input-file"
    />
    <p v-if="!fileName">
      Arraste seu arquivo aqui para começar <br />
      ou clique para fazer o upload <br />
      <i class="fa fa-cloud-upload"></i>
    </p>
    <p v-else>
      <i class="fa fa-list"></i>Arquivo {{ fileName }} ...
      <vs-button color="danger" size="small" @click="clickRemoveFile"
        >remover</vs-button
      >
    </p>
  </div>
</template>

<script>
//eventos
import { EventBusLogged } from "@/eventBus/eventBusLogged";

//configuração das mensagens
const configMessageNo = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "error",
  duration: 5000,
};

const configMessageYes = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "success",
  duration: 3000,
};

export default {
  name: "Uploader",
  data() {
    return {
      file: null,
      fileName: "",
    };
  },
  methods: {
    reset() {
      this.fileName = "";
      this.file = null;
    },
    filesChange(fieldName, fileList) {
      if (!fileList.length) return;

      const extension = this.getExtensionFile(fileList[0].name);
      if (extension != "pdf") {
        this.$toasted.show(
          `Não é suportado o tipo de arquivo (${extension})`,
          configMessageNo
        );
        return;
      }

      this.fileName = fileList[0].name;
      this.file = fileList[0];

      this.$emit("uploader", this.file);
    },
    clickRemoveFile() {
      this.file = null;
      this.fileName = "";

      const file = document.querySelector(".input-file");
      file.value = null;

      this.$emit("remover");
    },
    getExtensionFile(fileName) {
      return fileName.slice(
        (Math.max(0, fileName.lastIndexOf(".")) || Infinity) + 1
      );
    },
  },
  mounted() {
    this.reset();

    EventBusLogged.$on("limpar_uploader", () => {
      this.reset();
    });
  },
};
</script>

<style scoped>
.dropbox {
  outline: 3px dashed grey; /* the dash box */
  outline-offset: -10px;
  background-color: #001e4d1a;
  color: #001e4de3;
  height: 130px; /* minimum height */
  width: 1108px;
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  width: 100%;
  height: 130px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background-color: #001e4d33;
}

.dropbox p {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 28px 0 0 0;
  font-size: 1.2em;
  text-align: center;
}
</style>